import { render, staticRenderFns } from "./esgNewsCategory.vue?vue&type=template&id=6de08cd2&scoped=true"
import script from "./esgNewsCategory.vue?vue&type=script&lang=js"
export * from "./esgNewsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de08cd2",
  null
  
)

export default component.exports